import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=5bb40d48&scoped=true"
import script from "./AddAsset.vue?vue&type=script&lang=js"
export * from "./AddAsset.vue?vue&type=script&lang=js"
import style0 from "./AddAsset.vue?vue&type=style&index=0&id=5bb40d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb40d48",
  null
  
)

export default component.exports